import React, { useCallback } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const SelectorBox = ({ selected = false, label, text, showAdditionalText = false }) => {
  const selectorStyles = cn(styles.selector, {
    [styles.selected]: selected,
    [styles.unselected]: !selected,
  });

  return (
    <div className={selectorStyles}>
      <h6 className={styles.label}>{label}</h6>
      {showAdditionalText && text}
    </div>
  );
};

SelectorBox.propTypes = {
  selected: PropTypes.bool,
  showAdditionalText: PropTypes.bool,
  label: PropTypes.string,
  text: PropTypes.string,
};

const Selector = ({
  selected,
  value: radioValue,
  onChange,
  wrapperClass = '',
  label,
  text,
  showAdditionalText,
}) => {
  const onClick = useCallback(
    (rValue) => (event) => {
      const {
        target: { checked },
      } = event;
      onChange(checked ? rValue : null);
    },
    [selected],
  );

  return (
    <label className={wrapperClass}>
      <input
        type="radio"
        checked={selected}
        onClick={onClick(radioValue)}
        value={radioValue}
        className={styles.input}
      />
      <SelectorBox
        selected={selected}
        label={label}
        text={text}
        showAdditionalText={showAdditionalText}
      />
    </label>
  );
};

Selector.propTypes = {
  selected: PropTypes.bool,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  wrapperClass: PropTypes.string,
  label: PropTypes.string,
  text: PropTypes.string,
  showAdditionalText: PropTypes.bool,
};

export default Selector;

/*
  This component was created for use in Product Page initially. Usage may be extended to other pages in future

  Usage:
  import Selector from 'src/components/HTKit/Selector/Selector';

   <Selector
      value={PRODUCT_TYPE.NO_INSTALLATION}
      label="No Installation"
      wrapperClass={styles.wrapper}
    />
  <Selector
    value={PRODUCT_TYPE.WITH_INSTALLATION}
    label="Add Installation"
    wrapperClass={styles.wrapper}
    text={<Price />}
    showAdditionalText={showAdditionalText}
  />

  Props:
  text: This will add additional text under the selector label,
  showAdditionalText: There maybe other conditions to show/hide text,
                      for eg: on product page, the condition would be if the input is selected, do not show text.

*/
